import Tooltip from '@BUP/components/Generics/tooltip'
import styles from './survey-element.module.scss'
import { useGetOrganizationRecommendations } from '@BUP/hooks/Sociogram/recommendations/useGetOrganizationRecommendations'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import { useTranslation } from 'react-i18next'
import BupSpinner from '@BUP/components/Loading/Spinner'
import { useNavigate } from 'react-router-dom'

const ResourceButton = ({ result, courseName }) => {
  const i18n = useTranslation()
  const navigate = useNavigate()
  const { id: resultId, survey } = result
  const { id: surveyId, created_at: createdAt } = survey
  const { isLoadingRecommendations, dataRecommendations, errorResultRecommendations } = useGetOrganizationRecommendations()
  if (isLoadingRecommendations) return <BupSpinner size='small' />
  if (errorResultRecommendations) return null
  if (!dataRecommendations) return null

  const resource = dataRecommendations.find(elem => elem.resultId === result.id)
  const handleViewResources = () => {
    navigate(`/sociogram/${surveyId}/results/${resultId}/recommendations`, {
      state: { surveyName: courseName || survey.name }
    })
  }
  const createdAtISO = new Date(createdAt)
  const recommendationDate = new Date(2024, 0, 29)
  if (createdAtISO < recommendationDate) return null

  if (!resource) {
    return (
      <div className={styles.resource_button_wrapper}>
        <Tooltip text={i18n.t('pages.data.historicalSociogram.resources.button.tooltip')}>
          <ButtonComponent
            colorType='primary'
            buttonText={i18n.t('pages.data.historicalSociogram.resources.button.text')}
            size='small'
            className={styles.little_button}
            disabled
          />
        </Tooltip>
      </div>
    )
  }

  return (
    <div className={styles.resource_button_wrapper}>
      <ButtonComponent
        colorType='primary'
        buttonText={i18n.t('pages.data.historicalSociogram.resources.button.text')}
        size='small'
        onClick={() => handleViewResources()}
        className={styles.little_button}
      />
    </div>
  )
}

export default ResourceButton
